import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "text-sm" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "absolute right-0 hidden h-full items-center space-x-5 lg:flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "absolute bottom-0 left-0 w-full scale-0 transition-transform duration-300 lg:border-b-2 lg:border-current lg:group-hover:scale-100" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "container pointer-events-auto relative max-h-full overflow-y-auto overflow-x-hidden pb-40 lg:py-24" }
const _hoisted_11 = {
  key: 0,
  class: "container relative max-h-full overflow-y-auto overflow-x-hidden pb-52 pt-16 lg:overflow-visible lg:py-24"
}
const _hoisted_12 = { class: "grid overflow-y-auto overflow-x-hidden lg:grid-cols-3 lg:gap-x-28 lg:overflow-visible" }
const _hoisted_13 = {
  key: 0,
  class: "hidden lg:block"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["href", "target"]
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = {
  key: 0,
  class: "text-gray-400 lg:hidden"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = { class: "text-left" }
const _hoisted_22 = {
  key: 0,
  class: "pt-2 pb-3 text-gray-400 lg:hidden"
}
const _hoisted_23 = ["href", "target"]
const _hoisted_24 = ["href", "target"]
const _hoisted_25 = {
  key: 0,
  class: "absolute bottom-0 right-0 flex h-4 w-full bg-gradient-to-t from-white to-transparent"
}
const _hoisted_26 = ["href", "target"]
const _hoisted_27 = {
  key: 1,
  class: "absolute bottom-0 right-0 flex h-4 w-full bg-gradient-to-t from-white to-transparent"
}
const _hoisted_28 = {
  key: 1,
  class: "hidden w-full lg:col-start-3 lg:row-start-1 lg:block"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = { class: "font-medium uppercase tracking-wider" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "hidden lg:mt-16 lg:block" }
const _hoisted_34 = { class: "container lg:my-24" }
const _hoisted_35 = { class: "mb-4 font-light text-gray-400" }
const _hoisted_36 = { class: "grid grid-cols-4 gap-x-8" }
const _hoisted_37 = ["href"]
const _hoisted_38 = { class: "relative mb-4 h-0 pt-1/1" }
const _hoisted_39 = ["src", "alt"]
const _hoisted_40 = {
  key: 0,
  class: "text-sm font-bold uppercase"
}
const _hoisted_41 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_biz_icon = _resolveComponent("biz-icon")!
  const _component_biz_search_input = _resolveComponent("biz-search-input")!
  const _component_collapse_transition = _resolveComponent("collapse-transition")!
  const _component_product_navigation = _resolveComponent("product-navigation")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["fixed left-0 top-0 z-50 h-16 w-full border-b transition-all duration-1000 lg:h-18", [
            _ctx.transparent && !_ctx.isMenuOpen ? 'border-transparent' : 'border-gray-100',
            { 'delay-1000': _ctx.isClosing },
            { '-translate-y-full': !_ctx.showNavi && !_ctx.isMenuOpen }
        ]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["h-full bg-gradient-to-b transition-colors duration-500", [
                _ctx.transparent && !_ctx.isMenuOpen ? 'bg-transparent text-white' : 'bg-white',
                { 'delay-1000': _ctx.isClosing }
            ]])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["container relative z-50 flex max-h-screen flex-col lg:h-full lg:flex-row lg:items-center", { 'bg-white': _ctx.isMenuOpen }])
      }, [
        _createElementVNode("a", {
          href: _ctx.homeLink,
          class: _normalizeClass(["inline-flex h-16 w-fit items-center transition-colors lg:h-full", [
                        _ctx.transparent && !_ctx.isMenuOpen ? 'text-white' : 'text-gray-500',
                        { 'delay-1000': _ctx.isClosing }
                    ]])
        }, [
          _createVNode(_component_biz_icon, {
            class: "h-4 w-full fill-current lg:h-5",
            name: "bizerba-logo"
          })
        ], 10, _hoisted_1),
        _createElementVNode("button", {
          class: _normalizeClass(["absolute right-4 top-0 flex h-15 w-15 shrink-0 items-center justify-center lg:hidden", [_ctx.transparent && !_ctx.isMobileOpen ? 'text-white' : 'text-gray-500']]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobile && _ctx.toggleMobile(...args)))
        }, [
          _createVNode(_component_biz_icon, {
            class: "h-full w-full fill-current p-4",
            name: _ctx.isMenuOpen ? 'close' : 'open-burger'
          }, null, 8, ["name"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["-mx-8 overflow-y-auto overflow-x-hidden px-8 text-gray-500 lg:flex lg:h-full lg:items-center lg:text-current", { hidden: _ctx.openItem }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["-mx-8 self-stretch overflow-hidden px-8 text-xl font-light transition-all duration-150 lg:mx-0 lg:inline-block lg:max-h-full lg:px-0 lg:text-base lg:font-normal", [
                            _ctx.isMenuOpen ? 'max-h-screen' : 'max-h-0',
                            {
                                '-translate-x-full lg:transform-none': _ctx.openItem
                            }
                        ]])
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["overflow-hidden transition-all duration-500 lg:hidden", [
                            !_ctx.isMenuOpen || _ctx.openItem
                                ? 'mb-0 max-h-0'
                                : 'mb-52 mt-4 max-h-screen delay-500'
                        ]])
          }, [
            _renderSlot(_ctx.$slots, "meta"),
            _createElementVNode("div", {
              class: "group relative mt-4 flex h-full items-center text-gray-400",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openSiteNav(true))),
              onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openSiteNav(false)))
            }, [
              _createVNode(_component_biz_icon, {
                class: "mr-2 h-4.5 w-4.5 shrink-0 fill-current",
                name: "sites"
              }),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.site), 1),
              _createVNode(_component_biz_icon, {
                class: "ml-2 h-3 w-3 shrink-0 rotate-90 fill-current",
                name: "chevron-right"
              }),
              (_ctx.langNav.length > 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["ml-6 flex h-full items-center space-x-2 font-light text-gray-500", {
                                    'scrollbar-hide w-32 overflow-x-auto': _ctx.langNav.length > 4
                                }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langNav, (langItem, l) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: langItem.link
                      }, [
                        (langItem.active)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(langItem.label), 1))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: langItem.link,
                              class: "text-gray-400"
                            }, _toDisplayString(langItem.label.replace(/_.*$/, '')), 9, _hoisted_4)),
                        (l < _ctx.langNav.length - 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "|"))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 2))
                : _createCommentVNode("", true)
            ], 32)
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["group relative flex h-full cursor-pointer items-center", [
                                _ctx.transparent && !_ctx.isMenuOpen
                                    ? 'text-white'
                                    : 'text-gray-400 hover:text-gray-500'
                            ]]),
              onMouseenter: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hoverSearch && _ctx.hoverSearch(...args))),
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args)))
            }, [
              _createVNode(_component_biz_icon, {
                class: "hidden h-4.5 w-4.5 shrink-0 fill-current lg:mt-1 lg:block",
                name: "search"
              }),
              _hoisted_7
            ], 34),
            _createElementVNode("div", {
              class: "flex h-full space-x-5",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
            }, [
              _renderSlot(_ctx.$slots, "meta", {
                transparent: _ctx.transparent && !_ctx.isMenuOpen
              })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["group relative flex h-full cursor-pointer items-center", [
                                _ctx.transparent && !_ctx.isMenuOpen
                                    ? 'text-white'
                                    : 'text-gray-400 hover:text-gray-500'
                            ]]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openSiteNav(true))),
              onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openSiteNav(false)))
            }, [
              _createVNode(_component_biz_icon, {
                class: "hidden h-4.5 w-4.5 shrink-0 fill-current lg:mt-1 lg:block",
                name: "sites"
              }),
              _createElementVNode("span", {
                class: _normalizeClass([{ 'lg:scale-100': _ctx.siteNavOpen }, "absolute bottom-0 left-0 w-full scale-0 transition-transform duration-300 lg:border-b-2 lg:border-current lg:group-hover:scale-100"])
              }, null, 2)
            ], 34),
            (_ctx.langNav.length > 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["mt-1 flex h-full items-center space-x-1.5 font-light", { 'scrollbar-hide w-32 overflow-x-auto': _ctx.langNav.length > 4 }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langNav, (langItem, l) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: langItem.link
                    }, [
                      (langItem.active)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(langItem.label), 1))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: langItem.link,
                            class: _normalizeClass([
                                        _ctx.transparent && !_ctx.isMenuOpen
                                            ? 'text-gray-100'
                                            : 'text-gray-400'
                                    ])
                          }, _toDisplayString(langItem.label.replace(/_.*$/, '')), 11, _hoisted_9)),
                      (l < _ctx.langNav.length - 1)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: _normalizeClass([
                                        _ctx.transparent && !_ctx.isMenuOpen
                                            ? 'text-gray-100'
                                            : 'text-gray-400'
                                    ])
                          }, "|", 2))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], 2))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _createVNode(_component_collapse_transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_biz_search_input, {
              class: _normalizeClass(["lg:hidden", {
                            'translate-y-full': !_ctx.isMobileOpen
                        }]),
              "back-label": _ctx.backLabel,
              "search-link": _ctx.searchLink,
              placeholder: _ctx.searchPlaceholder
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "search-teasers")
              ]),
              _: 3
            }, 8, ["back-label", "search-link", "placeholder", "class"]), [
              [_vShow, _ctx.showNavi && (_ctx.isMenuOpen || _ctx.isMobileOpen)]
            ])
          ]),
          _: 3
        })
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["pointer-events-none fixed top-18 z-50 w-full overflow-hidden bg-white shadow-gray-400/10 transition-all duration-500 lg:pointer-events-auto lg:top-18", [
                _ctx.siteNavOpen
                    ? 'h-screen max-h-full lg:h-auto lg:min-h-[70vh] lg:shadow-lg'
                    : 'max-h-0 min-h-0'
            ]])
    }, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeSiteNav && _ctx.closeSiteNav(...args)), ["stop"])),
          class: "mb-6 flex items-center text-xs lg:hidden"
        }, [
          _createVNode(_component_biz_icon, {
            name: "chevron-right",
            class: "mr-2 h-2 w-1.5 rotate-180"
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.backLabel), 1)
        ]),
        _renderSlot(_ctx.$slots, "site"),
        (_ctx.siteNavOpen)
          ? (_openBlock(), _createBlock(_component_biz_search_input, {
              key: 0,
              class: "lg:hidden",
              "search-link": _ctx.searchLink,
              placeholder: _ctx.searchPlaceholder,
              "back-label": _ctx.backLabel
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "search-teasers")
              ]),
              _: 3
            }, 8, ["search-link", "placeholder", "back-label"]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["fixed top-0 z-40 w-full overflow-hidden bg-white text-gray-500 shadow-gray-400/10 transition-all duration-1000 lg:top-18 lg:shadow-lg", [_ctx.isMenuOpen ? 'h-screen lg:h-auto lg:min-h-[80vh]' : 'h-0 lg:min-h-0']])
    }, [
      _createVNode(_component_collapse_transition, null, {
        default: _withCtx(() => [
          (_ctx.openItem)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)), ["stop"])),
                  class: "absolute top-16 flex items-center text-xs lg:hidden"
                }, [
                  _createVNode(_component_biz_icon, {
                    name: "chevron-right",
                    class: "mr-2 h-2 w-1.5 rotate-180"
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.backLabel), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([{ 'lg:hidden': _ctx.productsOpen }, "mb-4 border-b-2 border-gray-500 pb-2 pt-8 text-xl font-light lg:border-none lg:py-0 lg:text-4xl"])
                }, _toDisplayString(_ctx.openItem.title), 3),
                _createElementVNode("div", _hoisted_12, [
                  (!_ctx.productsOpen)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", {
                          class: "mb-4 text-sm leading-[1.375rem] text-gray-400",
                          innerHTML: _ctx.openItem.text
                        }, null, 8, _hoisted_14),
                        (_ctx.openItem.link)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _ctx.openItem.link,
                              target: _ctx.openItem.target,
                              class: "button button-link text-sm"
                            }, _toDisplayString(_ctx.openItem.linkLabel ? _ctx.openItem.linkLabel : _ctx.toOverviewLabel), 9, _hoisted_15))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("ul", {
                      onScroll: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.checkItemsScrollbar && _ctx.checkItemsScrollbar(...args))),
                      ref: "scrollItems",
                      class: "scrollbar-hide -mt-2 lg:-mt-8 lg:max-h-[calc(75vh-5rem)] lg:overflow-auto lg:pb-6"
                    }, [
                      (_ctx.openItem.link)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                            _createElementVNode("a", {
                              href: _ctx.openItem.link,
                              class: "block py-3"
                            }, _toDisplayString(_ctx.openItem.title) + " " + _toDisplayString(_ctx.overviewLabel), 9, _hoisted_18)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subItems, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.title,
                          class: "border-gray-100 lg:border-b"
                        }, [
                          (item.subItemsSize)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.openSubMenu(item)),
                                class: "group relative block w-full cursor-pointer py-3 font-light lg:pb-2 lg:pt-8 lg:text-lg"
                              }, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(item.title), 1),
                                  _createVNode(_component_biz_icon, {
                                    name: "chevron-right",
                                    class: _normalizeClass(["mx-2 h-2 w-1.5 lg:mr-0 lg:rotate-0", {
                                                    '-rotate-90': _ctx.openSubSubItem == item,
                                                    'rotate-90': _ctx.openSubSubItem != item
                                                }])
                                  }, null, 8, ["class"])
                                ]),
                                _createElementVNode("span", {
                                  class: _normalizeClass([{
                                                'scale-100':
                                                    _ctx.openSubItem === item || _ctx.openSubSubItem == item
                                            }, "absolute bottom-0 left-0 w-full origin-left scale-0 transition-transform duration-300 lg:border-b-2 lg:border-gray-500 lg:group-hover:scale-100"])
                                }, null, 2),
                                (_ctx.openSubSubItem == item)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subItems, (subitem) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          class: "py-2 text-left",
                                          key: subitem.title
                                        }, [
                                          _createElementVNode("a", {
                                            href: subitem.link,
                                            target: subitem.target
                                          }, _toDisplayString(subitem.title), 9, _hoisted_23)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_19))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: item.link,
                                target: item.target,
                                class: "group relative block cursor-pointer py-3 font-light lg:pb-2 lg:pt-8 lg:text-lg"
                              }, [
                                _createElementVNode("span", null, _toDisplayString(item.title), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass([{ 'scale-100': _ctx.openSubItem === item }, "absolute bottom-0 left-0 w-full origin-left scale-0 transition-transform duration-300 lg:border-b-2 lg:border-gray-500 lg:group-hover:scale-100"])
                                }, null, 2)
                              ], 8, _hoisted_24))
                        ]))
                      }), 128))
                    ], 544),
                    (_ctx.showItemsArrow)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                          _createVNode(_component_biz_icon, {
                            name: "chevron-right",
                            class: "mx-auto mt-auto h-2 w-1.5 rotate-90"
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["duration-400 relative bg-white transition-all ease-linear lg:col-start-3 lg:row-start-1", 
                                _ctx.openSubSubItem
                                    ? 'hidden opacity-100 lg:block'
                                    : 'pointer-events-none opacity-0'
                            ])
                  }, [
                    (_ctx.openSubSubItem)
                      ? (_openBlock(), _createElementBlock("ul", {
                          key: 0,
                          onScroll: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.checkItemsScrollbar && _ctx.checkItemsScrollbar(...args))),
                          ref: "scrollSubItems",
                          class: "scrollbar-hide -mt-2 lg:-mt-8 lg:max-h-[calc(75vh-5rem)] lg:overflow-auto lg:pb-6"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openSubSubItem.subItems, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: item.title,
                              class: "border-gray-100 lg:border-b"
                            }, [
                              _createElementVNode("a", {
                                href: item.link,
                                target: item.target,
                                class: "group relative block cursor-pointer py-3 font-light lg:pb-2 lg:pt-8 lg:text-lg"
                              }, [
                                _createElementVNode("span", null, _toDisplayString(item.title), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass([{ 'scale-100': _ctx.openSubSubItem === item }, "absolute bottom-0 left-0 w-full origin-left scale-0 transition-transform duration-300 lg:border-b-2 lg:border-gray-500 lg:group-hover:scale-100"])
                                }, null, 2)
                              ], 8, _hoisted_26)
                            ]))
                          }), 128))
                        ], 544))
                      : _createCommentVNode("", true),
                    (_ctx.showSubItemsArrow)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                          _createVNode(_component_biz_icon, {
                            name: "chevron-right",
                            class: "mx-auto mt-auto h-2 w-1.5 rotate-90"
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_ctx.openItem.teaserLink && !_ctx.openItem.cards)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("a", {
                          href: _ctx.openItem.teaserLink
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.openItem.teaserImage,
                            alt: _ctx.openItem.teaserImageAlt,
                            class: "mb-4 w-full object-cover object-center"
                          }, null, 8, _hoisted_30),
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.openItem.teaserKicker), 1),
                          _createElementVNode("div", {
                            class: "font-bold lg:text-lg",
                            innerHTML: _ctx.openItem.teaserTitle
                          }, null, 8, _hoisted_32)
                        ], 8, _hoisted_29)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_product_navigation, {
                    show: _ctx.productsOpen,
                    items: _ctx.products
                  }, null, 8, ["show", "items"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_collapse_transition, null, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_33, [
            _createVNode(_component_biz_search_input, {
              "back-label": _ctx.backLabel,
              onClose: _ctx.closeMenu,
              "is-open": _ctx.isSearchOpen,
              "search-link": _ctx.searchLink,
              placeholder: _ctx.searchPlaceholder,
              class: _normalizeClass([
                            _ctx.isSearchOpen ? 'items-center justify-between lg:flex' : 'lg:hidden'
                        ])
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "search-teasers")
              ]),
              _: 3
            }, 8, ["back-label", "onClose", "is-open", "search-link", "placeholder", "class"]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.popularLabel), 1),
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchTeasers, (searchTeaser) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: searchTeaser.id,
                    class: "block",
                    href: searchTeaser.link
                  }, [
                    _createElementVNode("div", _hoisted_38, [
                      (searchTeaser.image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: searchTeaser.image,
                            alt: searchTeaser.imageAlt,
                            class: "absolute left-0 top-0 h-full w-full object-cover object-center"
                          }, null, 8, _hoisted_39))
                        : _createCommentVNode("", true)
                    ]),
                    (searchTeaser.kicker)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.removeHtmlTags(searchTeaser.kicker)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "font-bold line-clamp-2",
                      innerHTML: _ctx.createHtmlTags(searchTeaser.title)
                    }, null, 8, _hoisted_41)
                  ], 8, _hoisted_37))
                }), 128))
              ])
            ])
          ], 512), [
            [_vShow, _ctx.showNavi && _ctx.isMenuOpen && _ctx.isSearchOpen]
          ])
        ]),
        _: 3
      })
    ], 2)
  ], 2))
}